var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widgets"},[_c('div',[_c('div',{staticClass:"sr-widget ",class:['sr-widget-betassist-' + this.uid]})])])}
var staticRenderFns = []

export { render, staticRenderFns }